<template>
  <div class="usc-backToTop mb">
    <button aria-label="back to top" v-on:click="smoothScroll">
      <img class="icon" src="../assets/large_arrow.svg" alt="Right Arrow">
    </button>
  </div>
</template>

<script>
import { TweenMax } from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'

export default {
  name: 'BackToTop',
  props: [],
  data () {
    return {

    }
  },
  methods: {
    smoothScroll () {
    // Scroll to the top
      TweenMax.to(window, 0.75, {
        scrollTo: 0,
        ease: 'linear',
        onComplete: this.resetFocus
      })
    },
    resetFocus () {
      // Set focus to the first focusable element at the top
      const focusableElement = document.querySelector('a, button, input, [tabindex="0"]')
      if (focusableElement) {
        focusableElement.focus()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';

  .usc-backToTop {
    button {
      background-color: #CCC;
      width: 64px;
      height: 60px;
      display: block;
      margin-left: auto;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      .icon {
        height: 26px;
        transform: rotate(-90deg);
        opacity: 0.6;
        display: block;
        margin: 0 auto;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/BackToTop.vue